import React, { useState } from 'react';
import InputId from './InputId';
import InputPhoneNumber from './InputPhoneNumber';
import FindThenChangePassword from './FindThenChangePassword';
import smartLabLogo from '@assets/logo/smartLab_logo(black).png';
import kisLogo from '@assets/logo/kisPayment_logo(black_horizontal).png';
import Cookies from 'js-cookie';

const FindPasswordContainer = () => {
  const [inputId, setInputId] = useState('');
  const [inputPhone, setInputPhone] = useState('');
  const userType = Cookies.get('userType');

  const inputIdHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setInputId(e.target.value);
  };

  const phoneInputHandler = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const value = event.target.value;
    const sanitizedValue = value.replace(/\D/g, '').slice(0, 11);
    setInputPhone(sanitizedValue);
  };

  return (
    <div className="find_password_wrapper">
      {userType === 'kis' ? (
        <img src={kisLogo} alt="로고" className="logo" />
      ) : (
        <img src={smartLabLogo} alt="로고" className="logo" />
      )}
      <InputId inputId={inputId} inputIdHandler={inputIdHandler} />
      <InputPhoneNumber inputPhone={inputPhone} phoneInputHandler={phoneInputHandler} />
      <FindThenChangePassword />
    </div>
  );
};

export default FindPasswordContainer;
